module.exports = __webpack_public_path__ + "static/img/wenjuan.fba8eda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenjuan.png
// module id = BwUg
// module chunks = 1